import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '../../../create-mock-endpoint';

import { GiftBalanceAdjustmentSalesManagementResponse } from '@/repositories/generated';

const response: GiftBalanceAdjustmentSalesManagementResponse[] = [
  {
    giftSalesManagementId: 1,
    name: '初回販売',
    expiresEndsAt: '2026-06-30T17:00:00+09:00',
  },
  {
    giftSalesManagementId: 2,
    name: '追加販売',
    expiresEndsAt: '2026-12-31T23:59:59+09:00',
  },
];

export const walletUserGiftBalanceSalesManagements = http.get(
  createMockEndpoint('/wallet_user/:walletUserId/gift_balance_adjustment/sales_managements'),
  async () => {
    await delay(300);
    return HttpResponse.json(response, { status: 200 });
  },
);
